import { render } from "./admin-workspace-department.vue?vue&type=template&id=4d95af94"
import script from "./admin-workspace-department.vue?vue&type=script&lang=js"
export * from "./admin-workspace-department.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/applications/admin/admin-workspace-department.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4d95af94"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4d95af94', __exports__)) {
    api.reload('4d95af94', __exports__)
  }
  
  module.hot.accept("./admin-workspace-department.vue?vue&type=template&id=4d95af94", () => {
    api.rerender('4d95af94', render)
  })

}


export default __exports__